import styled from "@emotion/styled";
import React, { useState, useEffect } from "react";

import { DarkModeOverride } from "../../../contexts/Theme";
import {
  OneClickSignInDialog,
  type OneClickSignInDialogProps,
} from "../../modules/OneClickSignIn/OneClickSignInDialog";
import type { INavigationProps } from "../types";

import {
  CtaButton,
  Header,
  Logo,
  Menu,
  MenuButton,
  Nav,
  NavItemList,
  MobileCTALoadingStencil,
} from "./elements";

const DialogWrapper = styled.div(({ theme }) => ({
  display: "none",
  [theme.breakpoints.nav.SML]: {
    display: "block",
  },
  [theme.breakpoints.phone]: {
    display: "none",
  },
}));

export default function MobileNavigation({
  className,
  currentPageSlug,
  data,
  disableLogoLink,
  hideLeft,
  hideRight,
  loading,
  oneClickSignInDialogProps,
  darkModeNav,
}: INavigationProps & {
  oneClickSignInDialogProps?: OneClickSignInDialogProps;
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const cta = (data.right || [])[(data.right || []).length - 1];

  useEffect(() => {
    // When the page navigates, close the nav.
    setIsMenuOpen(false);
  }, [currentPageSlug]);

  const RightCta = cta && !hideRight && (
    <NavItemList>
      <li>
        <CtaButton
          to={cta.link.to || cta.link.toExternal || cta.link.hash || "#"}
        >
          {cta.text}
        </CtaButton>{" "}
      </li>
    </NavItemList>
  );

  return (
    <DarkModeOverride useDarkMode={darkModeNav ?? false}>
      <Header className={className}>
        <Nav>
          <NavItemList>
            {!hideLeft && (
              <li>
                <MenuButton onClick={() => setIsMenuOpen(true)} />
              </li>
            )}
            <li>
              <Logo disableLink={disableLogoLink} />
            </li>
          </NavItemList>
          {loading ? <MobileCTALoadingStencil /> : RightCta}
        </Nav>
        {oneClickSignInDialogProps &&
          oneClickSignInDialogProps.shouldShowPopup && (
            <DialogWrapper>
              <OneClickSignInDialog
                shouldShowPopup={oneClickSignInDialogProps.shouldShowPopup}
                optIn={oneClickSignInDialogProps.optIn}
                optOut={oneClickSignInDialogProps.optOut}
              />
            </DialogWrapper>
          )}
      </Header>
      <Menu
        loading={loading}
        className={className}
        data={data}
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        darkModeNav={darkModeNav}
      />
    </DarkModeOverride>
  );
}
